<template>
  <div>
    <button class="btn btn-green" @click="showModal">+ New cash payment</button>

    <!-- Modal -->
    <div class="transfer_modal modal fade" ref="cashPaymentModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-size" role="document">
        <div class="modal-content fixed-modal">
          <div class="modal-body">
            <div class="transfer_modal_header d-flex justify-content-between">
              <h5 class="modal-title" id="exampleModalLabel">New cash payment</h5>
              <button type="button" class="close btn" @click="hideModal" aria-label="Close">
                X
              </button>
            </div>
            <div class="row d-flex align-items-stretch">
              <div class="col-md-3 col-12 mb-3 mb-md-0 d-flex align-items-stretch">
                <!-- 輸入Driver ID 查詢司機交易資訊 -->
                <div class="card h-100">
                  <div class="card-body">
                    <h5>Licensing & Operations</h5>
                    <div class="form-group">
                      <label for="driver-id">Driver ID</label>
                      <input type="text" id="driver-id" class="form-control" v-model="cashPaymentStore.filters.driverID" @input="handleDriverIDInput" @keyup.enter="fetchDriverData" data-bs-toggle="tooltip" title="Please press Enter after entering ID" />
                    </div>
                    <div class="form-group">
                      <label for="driver-name">Name</label>
                      <input type="text" id="driver-name" class="form-control" :value="driverFullName" disabled />
                    </div>
                    <div class="form-group">
                      <label for="plate">Plate</label>
                      <input type="text" id="plate" class="form-control" :value="cashPaymentStore.driverInfo.plateNumber" disabled />
                    </div>
                    <div class="form-group">
                      <div class="license-card">
                        <label for="driver-license">Associated driving license</label>
                        <img 
                          :src="cashPaymentStore.driverInfo.licenseFrontUrl || defaultLicenseImage" 
                          alt="Driver License" 
                          class="img-fluid mb-2 mt-2 driver-license-image"
                          @click="showLicenseModal(cashPaymentStore.driverInfo.licenseFrontUrl || defaultLicenseImage)" />
                        <div class="d-flex justify-content-end">
                          <button class="btn btn-query" @click="fetchDriverData">Query</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-9 col-12">
                <!-- 計算交易資訊 -->
                <div class="card">
                  <div class="card-body">
                    <h5>Payment info</h5>
                    <div class="table-responsive">
                      <table class="table table-bordered table-hover">
                        <thead class="thead-light">
                          <tr>
                            <th>Transactions</th>
                            <th>$SFV</th>
                            <th>Commission amount</th>
                            <th>Fees & Refunds</th> 
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{ selectedSummary.transactionCount }}</td>
                            <td>{{ formatCurrency(selectedSummary.totalSFV) }}</td>
                            <td>{{ formatCurrency(selectedSummary.totalCommissionAmount) }}</td>
                            <td>{{ formatCurrency(cashPaymentStore.fees_and_refunds) }}</td>
                            <td>{{ formatCurrency(selectedSummary.totalAmount) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!-- 查詢後的司機交易資訊 -->
                <div class="card mb-0 payment-info-h h-auto">
                  <div class="card-body">
                    <div class="transfer_card_title card-title row">
                      <div class="transfer_card_title_left col-12 col-md-8 row">
                        <div class="col-xxl-5 col-md-6 d-flex align-items-center justify-content-between">
                          <label for="from-date me-2">From</label>
                          <Datepicker1 v-model="fromDate" :format="format" class="datepicker-here form-control" data-language="en" :enable-time-picker="false" placeholder="Select..." />
                        </div>
                        <div class="col-xxl-5 col-md-6 d-flex align-items-center justify-content-between">
                          <label for="to-date me-2">to</label>
                          <Datepicker1 v-model="toDate" :format="format" class="datepicker-here form-control" data-language="en":enable-time-picker="false"  placeholder="Select..." />
                        </div>
                        <div class="col-xxl-2 col-md-6 d-flex align-items-center justify-content-between">
                          <select v-model="cashPaymentStore.itemsPerPageTransactions" @change="handlePageSizeChange" class="form-select ms-2" style="width: auto;">
                            <option v-for="option in cashPaymentStore.pageSizeOptions" :key="option" :value="option">
                              {{ option }} per page
                          </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-1"></div>
                      <div class="col-12 col-md-3 text-end d-flex justify-content-end bg-lightgreen">
                        <div class="d-inline-block d-flex justify-content-between align-items-center">          
                              <span class="w-100 me-3">No. reversals</span>
                              <input type="text" class="form-control" value="12345" readonly/>             
                        </div>
                      </div>
                    </div>
                    <div class="table-responsive mt-3">
                      <table class="table table-hover">
                        <thead class="thead-light">
                          <tr>
                            <th>Select</th>
                            <th>Tx Date/Time</th>
                            <th>Type</th>
                            <th>Driver name</th>
                            <th>Driver ID</th>
                            <th>Face value</th>
                            <th>Comm'n %</th>
                            <th>Comm'n amount</th>
                            <th>Bank ref</th> 
                            <th>Terminal</th>
                            <th>Card type</th>
                            <th>Card last 4 digits</th>
                          </tr>
                        </thead>
                        <tbody v-if="cashPaymentStore.transactions.length === 0">
                          <tr>
                            <td colspan="12">
                              <div class="no-results">No results found.</div>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr v-for="(item, index) in cashPaymentStore.paginatedTransactions" :key="index">
                            <td>
                              <div class="checkbox-success">
                                <input type="checkbox" v-model="item.selected" @change="updateSelectedSummary" />
                              </div>
                            </td>
                            <td>{{ item.transaction_datetime }}</td>
                            <td>{{ item.type }}</td>
                            <td>{{ item.driver_name }}</td>
                            <td>{{ cashPaymentStore.driverInfo.driverID }}</td>
                            <td>{{ item.face_value }}</td>
                            <td>{{ item.commn_percent }}</td>
                            <td>{{ item.comm_amount }}</td>
                            <td>{{ item.rrn }}</td> 
                            <td>{{ item.tid }}</td>
                            <td>{{ item.card_type }}</td>
                            <td>{{ item.card_last_4_digits }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- 分頁以及全選 -->
                    <div class="pagination-wrapper" v-if="cashPaymentStore.paginatedTransactions != ''">
                      <div class="pagination-container">
                        <button @click="changeTransactionPage(1)" :disabled="cashPaymentStore.currentPageTransactions === 1"><img  src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" style="width: 25px; height: 25px;" /></button>
                        <button @click="changeTransactionPage(cashPaymentStore.currentPageTransactions - 1)" :disabled="cashPaymentStore.currentPageTransactions === 1"><img  src="@/assets/images/admin/arrow/prev.png" alt="Prev" style="width: 25px; height: 25px;" /></button>
                        <span>Page <input type="number" v-model.number="cashPaymentStore.currentPageTransactions" @change="changeTransactionPage(cashPaymentStore.currentPageTransactions)" /> of {{ cashPaymentStore.totalTransactionPages }}</span>
                        <button @click="changeTransactionPage(cashPaymentStore.currentPageTransactions + 1)" :disabled="cashPaymentStore.currentPageTransactions === cashPaymentStore.totalTransactionPages"><img  src="@/assets/images/admin/arrow/next.png" alt="Next" style="width: 25px; height: 25px;" /></button>
                        <button @click="changeTransactionPage(cashPaymentStore.totalTransactionPages)" :disabled="cashPaymentStore.currentPageTransactions === cashPaymentStore.totalTransactionPages"><img  src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" style="width: 25px; height: 25px;" /></button>
                        <!-- 全選交易按鈕 -->
                        <button class="btn btn-selectall" @click="selectAllTransactions">{{ isSelectAllTransactions ? 'Deselect All' : 'Select All' }}</button>
                      </div>
                      <div class="total-count">
                        Displaying transactions {{ (cashPaymentStore.currentPageTransactions - 1) * cashPaymentStore.itemsPerPageTransactions + 1 }} – {{ Math.min(cashPaymentStore.currentPageTransactions * cashPaymentStore.itemsPerPageTransactions, cashPaymentStore.totalEntries) }} of {{ cashPaymentStore.totalEntries }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 操作按鈕 -->
            <div class="transfer_footer modal-footer">
              <button class="btn btn-green" :disabled="selectedSummary.totalAmount <= 0  || cashPaymentStore.isDataFetched === false" @click="handSaveAndEmail">Save + email + close</button>
              <button class="btn btn-green" :disabled="selectedSummary.totalAmount <= 0  || cashPaymentStore.isDataFetched === false" @click="handSaveAndPrint">Save + print + close</button>
              <button class="btn btn-green" :disabled="selectedSummary.totalAmount <= 0  || cashPaymentStore.isDataFetched === false" @click="handleSaveClose">Save + close</button>
              <button class="btn btn-w" @click="hideModal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 放大駕照的Moadl -->
    <div class="modal fade" ref="licenseModal" tabindex="-1" role="dialog" aria-labelledby="licenseModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="licenseModalLabel">Driving License</h5>
            <button type="button" class="close" @click="hideLicenseModal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <img :src="currentLicenseImage" alt="Driver License" class="img-fluid" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="emailLoading" class="spinner-overlay">
        <div class="spinner"></div>
    </div>
  </div>
</template>
 
<script setup>
import { ref, computed, watch, onMounted, nextTick } from 'vue';
import { Modal, Tooltip } from 'bootstrap';
import { useCashPaymentStore } from '@/store/admin/cashPayment/cashpayment';
import { usePaymentListStore } from '@/store/admin/cashPayment/paymentList';

import Datepicker1 from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

const cashPaymentStore = useCashPaymentStore();
const cashPaymentListStore = usePaymentListStore();

const cashPaymentModal = ref(null);
let modalInstance = null;
let fromDate = ref('');
let toDate = ref('');
let isSelectAllTransactions = ref(false);
const currentLicenseImage = ref(null); // 用於存儲當前駕照圖片的 URL
const licenseModal = ref(null); // 用於存儲模態框的引用
let licenseModalInstance = null; // 模態框的實例

//預設駕照圖片
const defaultLicenseImage = require('@/assets/images/admin/cashpayments/image.png');

//日期格式化
const format = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

const formatCurrency = (value) => {
    const absValue = Math.abs(value).toFixed(2); // 取得絕對值並固定為兩位小數
    return value < 0 ? `-$${absValue}` : `$${absValue}`;
};

// 顯示模態框
const showModal = () => {
  if (!modalInstance) {
    modalInstance = new Modal(cashPaymentModal.value);
  }
  modalInstance.show();
  cashPaymentStore.shouldFetchData = true;  // 當模態框打開時允許 API 調用
};

// 隱藏模態框並重置資料
const hideModal = () => {
  if (modalInstance) {
    fromDate.value = '';
    toDate.value = '';
    resetFormData(); // 重置所有表單和查詢資料
    cashPaymentStore.shouldFetchData = false;  // 關閉模態框時禁止 API 調用
    modalInstance.hide();
  }
};

// 顯示駕照模態框
const showLicenseModal = (imageUrl) => {
  currentLicenseImage.value = imageUrl; // 設置駕照圖片 URL
  licenseModalInstance.show(); // 顯示模態框
};

// 隱藏駕照模態框
const hideLicenseModal = () => {
  licenseModalInstance.hide(); // 隱藏模態框
};

// 重置所有表單和查詢資料
const resetFormData = () => {
  cashPaymentStore.resetDriverData(); // 重置 Pinia Store 中的資料
  cashPaymentStore.filters.driverID = '';
  updateSelectedSummary(); // 重置選擇的交易統計數據
};

// 獲取司機數據並更新交易列表
const fetchDriverData = async () => {
  // 僅在需要時調用 API
  if (cashPaymentStore.shouldFetchData) {
    try {
      await cashPaymentStore.fetchDriverTransactions();
      updateSelectedSummary(); // 更新選擇的交易統計數據
    } catch (error) {
      console.error("Failed to fetch driver data:", error);
    }
  }
};

// 監聽日期變化
watch(
  () => [fromDate.value, toDate.value],
  () => {
    if (cashPaymentStore.shouldFetchData) {
      cashPaymentStore.filters.fromDate = fromDate.value;
      cashPaymentStore.filters.toDate = toDate.value;
      fetchDriverData();  // 日期變化時自動調用
    }
  }
);

// 當 driverID 改變時重置數據
const handleDriverIDInput = () => {
  cashPaymentStore.resetDriverData();
  resetSelection();
};

// 計算司機全名
const driverFullName = computed(() => `${cashPaymentStore.driverInfo.firstName} ${cashPaymentStore.driverInfo.lastName}`);

// 初始化選擇的交易統計數據
const selectedSummary = ref({
  transactionCount: 0,
  totalSFV: 0,
  totalCommissionAmount: 0,
  totalAmount: 0,
});

// 更新選擇的交易統計數據
const updateSelectedSummary = () => {
  const summary = cashPaymentStore.transactions.reduce(
    (acc, transaction) => {
      if (transaction.selected) {
        acc.transactionCount += 1;
        acc.totalSFV += parseFloat(transaction.face_value) || 0;
        acc.totalCommissionAmount += parseFloat(transaction.comm_amount) || 0;
      }
      return acc;
    },
    {
      transactionCount: 0,
      totalSFV: 0,
      totalCommissionAmount: 0,
      totalAmount: 0,
    }
  );

  // 總金額 = 選中的交易總額 + fees & refunds
  summary.totalAmount = summary.totalSFV + summary.totalCommissionAmount + cashPaymentStore.fees_and_refunds;

  selectedSummary.value = summary;
};

// 全選交易
const selectAllTransactions = () => {
  if(!isSelectAllTransactions.value){
    cashPaymentStore.transactions.forEach(transaction => {
    transaction.selected = true;
  });
  }else{
    cashPaymentStore.transactions.forEach(transaction => {
    transaction.selected = false;
  });
  }
  isSelectAllTransactions.value = !isSelectAllTransactions.value;
  updateSelectedSummary();
};

// 切換交易頁面
const changeTransactionPage = (page) => {
  if (page >= 1 && page <= cashPaymentStore.totalTransactionPages) {
    cashPaymentStore.currentPageTransactions = page;
    updateSelectedSummary();
  }
};

// 重置選擇
const resetSelection = () => {
  cashPaymentStore.transactions.forEach(transaction => {
    transaction.selected = false;
  });
  updateSelectedSummary();
};

const emailLoading = ref(false);

//儲存並寄送Email
const handSaveAndEmail = async () =>{
  const selectedTransactionIds = cashPaymentStore.transactions
    .filter(t => t.selected)
    .map(t => t.id);
    
  // 如果沒有選中交易但有 fees & refunds，傳遞空陣列
  const transactionIds = selectedTransactionIds.length > 0 ? selectedTransactionIds : [];
  
  const paymentId = await cashPaymentStore.createCashPayment(transactionIds);
  if(paymentId != false){
    try {
      emailLoading.value = true;
      await cashPaymentStore.mailPayments(paymentId);
      cashPaymentListStore.changePage(1);
      hideModal();
    }catch(error){
      console.error(error);
    }finally {
      emailLoading.value = false;
    }
  }
};

//儲存並且印出
const handSaveAndPrint = async () =>{
  const selectedTransactionIds = cashPaymentStore.transactions
    .filter(t => t.selected)
    .map(t => t.id);
    
  // 如果沒有選中交易但有 fees & refunds，傳遞空陣列
  const transactionIds = selectedTransactionIds.length > 0 ? selectedTransactionIds : [];
  
  const paymentId = await cashPaymentStore.createCashPayment(transactionIds);
  // 如果 API 成功返回 payment_id
  if (paymentId) {
    cashPaymentStore.printPayments(paymentId); // 調用 Pinia 中的 printPayments 方法
    cashPaymentListStore.changePage(1);
    hideModal();
  }
};

//儲存並關閉
const handleSaveClose = async () => {
  const selectedTransactionIds = cashPaymentStore.transactions
    .filter(t => t.selected)
    .map(t => t.id);

  // 如果沒有選中交易但有 fees & refunds，傳遞空陣列
  const transactionIds = selectedTransactionIds.length > 0 ? selectedTransactionIds : [];

  const res = await cashPaymentStore.createCashPayment(transactionIds);
  if (res != false) {
    cashPaymentListStore.changePage(1);
    hideModal();
  }
};

// 初始化 Tooltip
const initializeTooltip = () => {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  tooltipTriggerList.forEach(tooltipTriggerEl => {
    new Tooltip(tooltipTriggerEl);
  });
};

onMounted(() => {
  licenseModalInstance = new Modal(licenseModal.value);
  initializeTooltip();
});

// 在 script setup 部分添加新的方法
const handlePageSizeChange = () => {
  // 當每頁顯示筆數改變時，重置到第一頁
  cashPaymentStore.currentPageTransactions = 1;
  updateSelectedSummary();
};

</script>

<style scoped>


.btn-query {
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  text-align: center;
  gap: 10px;
  width: 89px;
  height: 34.2px;
  background: #04FF7F;
  border-radius: 27.8571px;
  flex: none;
  order: 2;
  flex-grow: 0;
}

.btn-green:hover {
  background: #00b452;
}

.modal-size {
  max-width: 80%;
}
.bg-lightgreen {
  background-color: #b8e3d0;
  padding: 10px;
  border-radius: 5px;
}

.table-responsive {
  max-height: 300px;
  overflow-y: auto;
  padding-top: 0px;
}

.driver-license-image {
  max-width: 100%;
  max-height: 200px;
  object-fit: cover;
}

.no-results {
  border-radius: 20px;
  padding: 50px;
  font-size: 20px;
  text-align: center;
  color: black;
  background-color: #ccd3da;
}

.d-flex {
  display: flex;
  align-items: flex-start;
}

.fixed-modal {
  overflow: hidden;
}

.form-group {
  margin-top: 10px;
}

.license-card {
  border-radius: 5px;
  padding: 5px;
  padding-top: 10px;
  background-color: white;
}

.thead-light th {
  background-color: #f8f9fa;
  color: #495057;
}

.modal-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  justify-content: space-between;
}


.table-responsive .table tbody tr td:nth-child(n+2) {
  min-width: 150px !important;
}

.card {
  background-color: #e6e9ec;
}

.card-body {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.payment-info-h{
    min-height: 450px;
  }

@media (max-width: 768px) {
  .modal-size {
    max-width: 100%;
  }
  .table-responsive {
    max-height: 250px;
  }
  .table {
    font-size: 12px;
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.pagination-container {
  display: flex;
  align-items: center;
}

.pagination-container button {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  color: #8476f4;
}

.pagination-container span {
  margin: 0 10px;
}

.pagination-container input {
  width: 50px;
  text-align: center;
}

.total-count {
  font-size: 16px;
  color: #666;
}

/* Loading overlay 與 spinner 樣式 */
.spinner-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
  }

  .spinner {
    width: 60px;
    height: 60px;
    border: 6px solid #f3f3f3;
    border-top: 6px solid #00c962;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

@media (max-width: 630px) {
  .pagination-wrapper {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .pagination-summary {
    margin-top: 10px;
    justify-content: center;
  }
  .pagination-container {
    justify-content: center;
    width: 100%;
    margin-bottom: 10px;
  }
}

@media (max-width: 768px) {
  .card-body {
    padding: 10px;
  }
  .filter-toggle-icon {
    justify-content: center;
    font-size: 20px;
  }
  .btn-reset, .btn-green, .btn-toggle {
    width: 100%;
    margin-top: 10px;
  }
  .btn-reset {
    margin-right: 0;
  }
  .text-end {
    text-align: center !important;
  }
}
</style>
